import Styled, { css } from 'styled-components';

const DropDownStyle = Styled.div`
  display: flex;
  justify-content: initial;
  align-items: center;
  transition: all .3s ease 0s;
  ${({ theme }) =>
    theme.fullWidth &&
    css`
      width: -webkit-fill-available;
    `}
  min-width: 130px;
`;

const DropDownContainer = Styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ theme }) =>
    theme.fullWidth &&
    css`
      width: -webkit-fill-available;
    `}
  min-width: 130px;
  
  > button {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    padding: 10px 12px;
    outline: 0;
    margin: 0;
    cursor: pointer;
    margin-left: auto;
    margin-top: auto;
    background: none;
    font-weight: normal;
    color: #666;
    font-size: 16px;
    border: 1px solid #666;
    text-transform: ${({ theme }) => theme.btnTextTransform};
    ${({ theme }) =>
      theme.fullWidth &&
      css`
        width: -webkit-fill-available;
      `}
    min-width: 130px;

    &:hover {
      color: #000;
      border-color: #000;
    }
    
    &:disabled {
      opacity: .6;
    }
    
    &.icon {
      border: none;
      font-weight: normal;
      background: none;
      padding: 0;
      margin: 0;
      
      &:hover,
      &:active {
        transition: all .1s ease;
        fill: #000;
        color: #000;
        border-color: #000;
      }
    }

    > svg {
      transition: all .5s ease 0s;
      width: 15px;
      height: 15px;
      margin-left: 15px;

      > path {
        stroke: #f8f8f8;
      }
      
      &.chevron-down {
        transform: rotate(-180deg);
        transform-origin: 50% 50%;
      }

      &.chevron-right{
        transform: rotate(0deg);
        transform-origin: 50% 50%;
      }
    }
  }
`;

const ListDropDown = Styled.div`
  box-shadow: rgb(0 0 0 / 15%) 0px 1px 35px 4px;
  background-color: #FFF;
  backdrop-filter: blur(10px);
  border: 1px solid #f8f8f8;
  position: absolute;
  border-radius: 5px;
  left: ${({ theme }) => theme.left};
  top: ${({ theme }) => theme.top};
  right: ${({ theme }) => theme.right};
  bottom: ${({ theme }) => theme.bottom};
  z-index: 100;
  height: auto;
  opacity: 0;
  visibility: hidden;
  height: auto;
  min-width: 250px;
  ${({ theme }) =>
    theme.fullWidth &&
    css`
      width: calc(100vw - 48px);
    `}
  transition: all .3s ease-in-out;
  overflow: ${({ theme }) => theme.overflow};
  overflow-y: inherit;
  z-index: 100;
  
  &.show-dropdown{
    opacity: 1;
    visibility: visible;
    cursor: pointer;
  }
`;

interface LabelProps {
  ellipsis?: boolean;
}

const Label = Styled.span<LabelProps>`
  ${({ ellipsis }) =>
    ellipsis &&
    css`
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      width: fit-content;
    `}
`;

export default DropDownStyle;
export { DropDownStyle, DropDownContainer, ListDropDown, Label };
